import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { Tag } from '@src/app/models/tag';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TagadminService {

  constructor(private http:HttpClient) { }

      //GET	    /organization/{organizationId}/tag/list/type/{tagtype}
      getTags(){
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json'
          })
        }
        return this.http.get<Tag[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/tag/list',httpOptions);
      }
        //Add new tag
  //POST	    /organization/{organizationId}/tag
  addTag(tag:Tag){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.post<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/tag',tag,httpOptions);
  }
  saveTag(tag:Tag){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.put<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/tag/'+tag.tagId,tag,httpOptions);
  }
  deleteTag(tag:Tag){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.delete<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/tag/'+tag.tagId,httpOptions);
  }
}
